import { FeatureSectionType } from "../../components/types";

export const getFeatureSections = (): FeatureSectionType[] => [
  {
    src: "",
    fallbackSrc: "/landing_page_assets/payor_network_page/one-partner.jpg",
    title: "One partner, one contract",
    description: [
      "Manage your plan's DME spend and care delivery under one risk-bearing contract that includes service quality SLAs.",
    ],
    className: "min440:tw-flex-row-reverse",
    features: [],
    hasButton: false,
    imageClassName: "tw-max-w-[440px] tw-max-h-[577px] tw-rounded-[32px]",
  },
  {
    src: "",
    fallbackSrc: "/landing_page_assets/payor_network_page/savings-on-dme.jpg",
    title: "10-20% savings on DME",
    description: [
      "Decrease total DME spend through Verse's utilization management technology, competitive unit cost, and network management capabilities.",
    ],
    features: [],
    hasButton: false,
    imageClassName: "tw-max-w-[440px] tw-max-h-[594px] tw-rounded-[32px]",
  },
  {
    src: "",
    fallbackSrc:
      "/landing_page_assets/payor_network_page/delighted-members.png",
    title: "Delighted members and prescribers",
    description: [
      "Create a DME experience that reduces grievances and builds trust with the people who matter most - your members and contracted clinicians.",
    ],
    className: "min440:tw-flex-row-reverse",
    features: [],
    hasButton: false,
    imageClassName: "tw-max-w-[440px] tw-max-h-[587px] tw-rounded-[32px]",
  },
];
